import React, { useEffect, useState } from "react";
import api from "../services/api";
import { toast } from "react-toastify";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { Download } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function AdmitCardDownloadFile() {
  const [schoolList, setSchoolList] = useState([]);
  const [schoolcount, setSchoolCount] = useState(0);
  const [backDropLoading, setBackDropLoading] = useState(false);
  const [schoolPageNumber, setSchoolPageNumber] = useState(0);
  const [totlaCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  const getSchoolData = async () => {
    try {
      setBackDropLoading(true);
      const response = await api.get(
        `compartment/admit-card-report?download=true&limit=5&offset=2`
      );
      // console.log(response, "response");

      setSchoolCount(response?.data?.data?.count);
      // console.log(response.data?.data, "responsedata");
      setSchoolList(response?.data?.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
    }
  };

  useEffect(() => {
    if (schoolList?.length) {
      let count = 0;
      schoolList?.forEach((item) => {
        // count = count + Number(item?.download_count);
        count += Number(item?.download_count);
      });
      setTotalCount(count);
    }
  }, [schoolList]);
  useEffect(() => {
    getSchoolData();
  }, []);

  const exportToCSV = () => {
    const csvContent = [
      "# , School Code ,School Name ,Download Count",
      ...schoolList.map((item, index) =>
        [
          index + 1,
          item?.sch || "-",
          item?.school_admit_card_details?.name || "-",
          item?.download_count || "-",
        ].join(",")
      ),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "AdmitCardDownloadReport.csv";
    link.click();
  };
  return (
    <Box
      sx={{
        textAlign: "center",
        width: "95%",
        justifySelf: "center",
        marginBottom: "25px",
      }}
    >
      <Box
        sx={{
          width: "470px",
          marginLeft: "auto",
          marginTop: "25px",
          marginBottom: "10px",
        }}
      >
        <Button
          //   variant="outlined"
          variant="contained"
          color="primary"
          onClick={() => navigate("/dashboard")}
          style={{
            marginRight: "10px",
            width: "60px",
          }}
        >
          Back
        </Button>
        <Button
          //   variant="outlined"
          variant="contained"
          color="primary"
          onClick={() => {
            exportToCSV();
          }}
          style={{
            marginLeft: "auto",
            width: "300px",
          }}
          startIcon={<Download />}
        >
          {totlaCount} Download Report
        </Button>
      </Box>
      <TableContainer // sx={{ maxHeight: "57vh", overflow: "auto" }}
        component={Paper}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
              <TableCell align="center">
                <strong>School Code </strong>
              </TableCell>
              <TableCell align="center">
                <strong>School Name</strong>
              </TableCell>

              <TableCell align="center">
                <strong>Download Count</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schoolList?.length > 0 ? (
              schoolList?.map((row) => (
                <TableRow
                  key={row?.id}
                  style={{
                    cursor: "pointer",
                    textWrap: "nowrap",
                    textAlign: "center",
                  }}
                >
                  <TableCell align="center">
                    {row?.sch ? row?.sch : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.school_admit_card_details?.name
                      ? row?.school_admit_card_details?.name
                      : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {row?.download_count ? row?.download_count : "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  {!backDropLoading && "No Schools found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Backdrop open={backDropLoading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default AdmitCardDownloadFile;
